// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_eg-0";
export var headerCellHover = "_eg-1";
export var readCellContainer = "_eg-2";
export var unreadIndicator = "_eg-3";